module.exports = __webpack_public_path__ + "img/gsjj.af5b7cdd.png";